import { render, staticRenderFns } from "./TableCellV2.vue?vue&type=template&id=9a1bdf04&scoped=true&"
import script from "./TableCellV2.vue?vue&type=script&lang=js&"
export * from "./TableCellV2.vue?vue&type=script&lang=js&"
import style0 from "./TableCellV2.vue?vue&type=style&index=0&id=9a1bdf04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a1bdf04",
  null
  
)

export default component.exports